import api from './Api';

class AuthService {
  constructor() {
    this.api = api;
  }

  signIn(payload) {
    return this.api.post('/auth/admin/sign_in', payload);
  }

  googleLogin(code) {
    return this.api.post(
      '/auth/admin/google',
      { code },
      {
        headers: {
          'Content-Type': 'application/json',
        },
      },
    );
  }

  forgotPassword(email) {
    return this.api.post(
      'auth/forgot-password',
      { email },
      { headers: { 'Content-Type': 'application/json' } },
    );
  }

  resetPassword(token, password) {
    return this.api.post(
      'auth/reset-password',
      { token, password },
      { headers: { 'Content-Type': 'application/json' } },
    );
  }
}

const authService = new AuthService();
export default authService;
